import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { TreasuriesService } from '../../services/treasuries.service';
import {
  LoadUSTreasuries,
  LoadUSTreasuriesFail,
  LoadUSTreasuriesSuccess,
  USTreasuriesActionTypes
} from './actions';
import { USTreasury } from '../../types/treasuries.types';

@Injectable()
export class USTreasuriesEffects {
  constructor(
    private actions$: Actions,
    private treasuriesService: TreasuriesService
  ) {}

  
  loadUSTreasuries$: Observable<
    LoadUSTreasuriesSuccess | LoadUSTreasuriesFail
  > = createEffect(() => this.actions$.pipe(
    ofType(USTreasuriesActionTypes.Load),
    switchMap((action: LoadUSTreasuries) =>
      this.treasuriesService.fetchData(action.payload.date).pipe(
        map((treasuries: USTreasury[]) => {
          return new LoadUSTreasuriesSuccess(treasuries);
        }),
        catchError((err: Error) =>
          of(new LoadUSTreasuriesFail(err && err.message))
        )
      )
    )
  ));
}
